"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const ChatMessageAttachmentStatus_1 = require("../ChatMessageAttachmentStatus");
class NullChatMessageAttachmentService {
    constructor() {
        this.IsConnected = false;
    }
    async InitAsync() { }
    async TerminateAsync() { }
    async ClearAsync() { }
    async UploadAttachment(cm, errorCallback, lastTryCount) { }
    async DownloadAttachment(cm, errorCallback, lastTryCount) { }
    async ReportNewAttachmentStatusAsync(attachmentName) { }
    QueryAttachmentStatusAsync(attachmentName) { throw new Error("Not Implemented."); }
    QueryAttachmentFilePathName(cm) { throw new Error("Not Implemented."); }
    RetrieveAttachmentBytesAsync(attachmentName) { throw new Error("Not Implemented."); }
    async QueryRemoteAttachmentStatus(cm, attachmentName) { return ChatMessageAttachmentStatus_1.Status.None; }
    async HasAttachmentAsync(name) { return false; }
    async SaveAttachmentAsync(name, attachmentBytes) { }
    async LoadAttachmentAsync(name) { throw new Error("Not Implemented."); }
    async DeleteAttachmentAsync(name) { throw new Error("Not Implemented."); }
}
exports.NullChatMessageAttachmentService = NullChatMessageAttachmentService;
exports.NullChatMessageAttachmentServiceSingleton = new NullChatMessageAttachmentService();
//# sourceMappingURL=NullChatMessageAttachmentService.js.map